<script setup lang="ts">
/* eslint-disable */
import { useAzureStore } from "@/stores/azure";
import { useEmbedStore } from "@/stores/embedStore";
import { PageDescription } from "@/types/PageDescriptionListItem";
import { ref, computed, onMounted } from "vue";
import { VueFinalModal } from "vue-final-modal";

const title = "Description";

const azureStore = useAzureStore();

const description = ref<PageDescription | null>(null);

const editDescriptionLink = computed(() => {
  return `https://abb.sharepoint.com/sites/NO-CompetenceLibrary/PA-OGC-KPI/Lists/PageDescriptions/EditForm.aspx?ID=${description.value?.id}`;
});

onMounted(async () => {
  const embedStore = useEmbedStore();
  await embedStore.getPageDescription().then((res) => {
    if (res) {
      // Update links in the description conten
      const updatedContent = updateLinksInDescription(res.Content);
      description.value = { ...res, content: updatedContent };
    } else {
      description.value = {
        id: 0,
        content: "Unable to load description",
        title: "",
        Content: "",
      };
    }
  });
  await azureStore.loadIsUserOwner();
});

const updateLinksInDescription = (htmlContent: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  doc
    .querySelectorAll("a[href^='/sites/'], img[src^='/sites/']")
    .forEach((el) => {
      const attr = el.tagName === "A" ? "href" : "src";
      el.setAttribute(
        attr,
        `https://abb.sharepoint.com${el.getAttribute(attr)}`
      );
    });

  return doc.body.innerHTML;
};
</script>

<template>
  <VueFinalModal
    class="desc-modal"
    content-class="desc-modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <template #default="{ close }">
      <div class="header">
        <span>{{ title }}</span>
        <div class="btn">
          <a
            :href="editDescriptionLink"
            target="_blank"
            v-if="azureStore.isUserOwner()"
          >
            <font-awesome-icon icon="fa-solid fa-edit" />
          </a>
          <button @click="() => close()">
            <font-awesome-icon icon="fa-solid fa-xmark" />
          </button>
        </div>
      </div>
      <div>
        <div v-html="description?.content" />
      </div>
    </template>
  </VueFinalModal>
</template>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #666;
}

.btn {
  color: #666;
  padding: 0px;
  margin: 0px;
  background: transparent;
  transition: 0.5s;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background-color: transparent;
    color: #111;
  }

  button {
    border: none;
    background: transparent;
    color: #666;
    cursor: pointer;

    & > .fa-xmark {
      font-size: 1.2rem;
      margin-top: -10px;
    }
  }

  & > a {
    color: #666;
    transition: 0.5s;

    &:hover {
      color: #111;
    }
  }
}
</style>

<style>
.desc-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 100vh;
}

.desc-modal-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  min-width: 850px;
  max-width: 1200px;
  width: 50%;
  overflow-y: auto;
  max-height: 90vh;
}

@media (max-width: 900px) {
  .desc-modal-content {
    min-width: unset;
    width: 95%;
    max-width: 95%;
    padding: 0.75rem;
    max-height: 95vh;
  }
}

@media (max-width: 480px) {
  .desc-modal-content {
    width: 100%;
    max-width: 100%;
    padding: 0.5rem;
    border-radius: 0;
  }
}

.desc-modal-content img {
  max-width: 100% !important;
  height: auto !important;
  width: auto !important;
  object-fit: contain;
  display: block;
}

.desc-modal-content > * + * {
  margin: 0.5rem 0;
}

.desc-modal-content h1 {
  font-size: 1.375rem;
}

.desc-modal-content button {
  margin: 0.25rem 0 0 auto;
  padding: 0 8px;
  border: 1px solid;
  border-radius: 0.5rem;
}

.dark .desc-modal-content {
  background: #000;
}
</style>
